import { useProducts } from "@/hooks/useProducts";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const FeaturedProducts = () => {
  const { data: products = [], isLoading } = useProducts();
  const featured = products.slice(0, 4);

  return (
    <section className="relative py-24">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="up">
          <div className="flex items-end justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-primary">Curated for you</p>
              <h2 className="mt-2 font-display text-3xl font-bold sm:text-4xl">Featured Drops</h2>
            </div>
            <Link to="/shop" className="hidden items-center gap-1 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground sm:flex">
              View All <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </ScrollReveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="animate-pulse rounded-2xl border border-border/50 bg-card">
                  <div className="aspect-square rounded-t-2xl bg-secondary" />
                  <div className="p-4 space-y-3">
                    <div className="h-4 w-2/3 rounded bg-secondary" />
                    <div className="h-4 w-1/3 rounded bg-secondary" />
                  </div>
                </div>
              ))
            : featured.map((p, i) => (
                <ScrollReveal key={p.id} direction="up" delay={i * 0.1}>
                  <ProductCard product={p} index={0} />
                </ScrollReveal>
              ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
